export const VIDEO_PREVIEW_EXTENSIONS = [
  "mp4",
  "mov",
  "avi",
  "wmv",
  "flv",
  "mkv",
  "webm",
];

const getExtension = (value) => {
  if (!value) return "";
  const cleanValue = String(value).split(/[?#]/)[0];
  const parts = cleanValue.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

export const isVideoPreviewFile = (
  file,
  { fileName = "", source = "" } = {},
) => {
  if (file && typeof file === "object") {
    const typeHints = [
      file.previewType,
      file.mediaType,
      file.kind,
      file.type,
      file.mimeType,
      file.contentType,
    ]
      .filter(Boolean)
      .map((value) => String(value).toLowerCase());

    if (
      Number(file.fileType) === 2 ||
      typeHints.some(
        (value) => value === "video" || value.startsWith("video/"),
      )
    ) {
      return true;
    }
  }

  return [fileName, source].some((value) =>
    VIDEO_PREVIEW_EXTENSIONS.includes(getExtension(value)),
  );
};
